import Compressor from 'compressorjs';
import configJson from 'config/config.json';
import { getChampionToken } from './championService';
import { advancedHandleResponse, handleResponse } from './apiService';
import { wait } from './utilsService';

export const getImageMeta = (url) =>
  new Promise((resolve, reject) => {
    const img = new Image();

    function loadImage() {
      img.removeEventListener('load', loadImage);
      img.removeEventListener('error', reject);
      resolve({
        width: this.naturalWidth,
        height: this.naturalHeight,
      });
    }

    img.addEventListener('error', reject);
    img.addEventListener('load', loadImage);
    img.src = typeof url === 'string' ? url : URL.createObjectURL(url);
  });

export const uploadFile = ({ file, url, progressCallback, doneCallback, errorCallback }) => {
  const xhr = new XMLHttpRequest();
  xhr.open('PUT', url, true);

  xhr.upload.addEventListener('progress', progressCallback);
  xhr.upload.addEventListener('load', doneCallback);
  xhr.upload.addEventListener('error', errorCallback);

  xhr.send(file);
};

export const compressImage = (file, url, compressorOptions = { quality: 0.6 }, skipUpload) =>
  new Promise((doneCallback, errorCallback) => {
    const success = skipUpload
      ? doneCallback
      : (result) => {
          uploadFile({
            file: result,
            url,
            doneCallback,
            errorCallback,
            progressCallback: () => {},
          });
        };

    const compressor = new Compressor(file, {
      ...compressorOptions,
      success,
      error: errorCallback,
    });
    console.log(compressor);
  });

const validateUploadedImage = async (url, tries, timeoutMS = 30 * 1000) => {
  const error = new Error(`Can't load image from ${url}`);
  const timeout = setTimeout(() => {
    throw error;
  }, timeoutMS);
  let meta = await getImageMeta(url).catch(console.log);
  if (meta) {
    clearTimeout(timeout);
    return;
  }
  const count = 0;
  while (!meta || count < tries) {
    /* eslint-disable no-await-in-loop */
    await wait(5 * 1000);
    meta = await getImageMeta(url).catch(console.log);
    /* eslint-enable no-await-in-loop */
  }
  if (meta) {
    clearTimeout(timeout);
    return;
  }
  throw error;
};

export const getFileUrl = async (file) => {
  const {
    presigned_url: url,
    upload_key: key,
    file_url: uploadUrl,
  } = await fetch(`${configJson.apiPath}/media/nft`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${getChampionToken()}` },
    body: JSON.stringify({ file_name: file?.name }),
  }).then(advancedHandleResponse);
  await new Promise((doneCallback, errorCallback) => {
    uploadFile({
      url,
      // file: blob,
      file,
      doneCallback,
      errorCallback,
    });
  });

  return uploadUrl;
};
export const createNFT = async (nftName, file) => {
  /*
  * file_url: "https://hpool-nfts-develop.s3.amazonaws.com/champion/193/7972885e0dd664e2db0775b4d66a799b-1641375501"
    mime_type: "image/png"
    presigned_url: "https://hpool-nfts-develop.s3.amazonaws.com/champion/193/7972885e0dd664e2db0775b4d66a799b-1641375501?AWSAccessKeyId=ASIAR5YGY442BNFYXSNX&Signature=b7UXpB3xckTQJwmQPgASWFNNZfQ%3D&content-type=image%2Fpng&x-amz-security-token=IQoJb3JpZ2luX2VjEIL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCXVzLWVhc3QtMSJHMEUCIDhujx6L2Hp%2BMuK49JMSvpa%2FhIVyQbfjFdddYW14utiiAiEAkemowAb8udtLP6PhFTgVMBJxPIelMq4Tvoo%2BCDV0UsIqpQIIi%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARABGgwxMzI2MjEzMzAyMjgiDEmL2MFE2C4R4xQ0fCr5AaR2k47xzsq2TTWqnpQM02GNRyAkIv324yfdIhVrsoPyBZ5OKeFo2QyE0EIqLoPxvQPujJEmyAuWuVcOEb4%2FVgFSCfeLhTxy3lT3%2BOFFpQPeD%2BjJ9Wh43dzfH0D5Ygzl83BEKLZafj18LNlB62x5jUBYcy0B3mg1RP7b27BEzndEOtXn6FiXv7bMlvNRKU4Y1l5RcfjBEjBVhzRkNDQSdQso1H48Gf2kZqteZhbnC37FJik3qEn50NC%2FebWdI3P6%2FTp%2B7MBp0yEEMOpCW4k%2BYSsoPWC5EjARIyxv3%2FrBSMEu%2F%2FKm3Gz22Y8K9OsMmmm0kcYKseuHoi5tSTCJztWOBjqaAQXTnhkJ19Zd4yTYrluMqD96NDBIGIZUTYz9wGXcGnLJ5RhOjpJdLBpvDOCu3GDU97YbqYONHPldaooHtzOIbLsZqAe8kAX%2BnO5fA1F4g5gBUXT80Nzo%2Bt6PvVVUKMYkq2hlCt47Y4VgeqpxMRNW3p5zocb7OtRKHQeLAwRQ0ZGMRJ8SbBDQWy6QIt6530aAmst90PQ%2BiE4v73A%3D&Expires=1641375801"
    upload_key
  * */
  try {
    const {
      presigned_url: url,
      upload_key: key,
      file_url: uploadUrl,
    } = await fetch(`${configJson.apiPath}/media/nft`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${getChampionToken()}` },
      body: JSON.stringify({ file_name: file.name }),
    }).then(advancedHandleResponse);

    await new Promise((doneCallback, errorCallback) => {
      uploadFile({
        url,
        // file: blob,
        file,
        doneCallback,
        errorCallback,
      });
    });
    await validateUploadedImage(uploadUrl);
    // if (window.enableCreation) {
    const result = await fetch(`${configJson.apiPath}/hpool_nft`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${getChampionToken()}` },
      body: JSON.stringify({ nft_name: nftName, image_s3_key: key, chain_id: window.chainId || configJson.network }),
    }).then(advancedHandleResponse);
    return result;
    // } else {
    //   return {};
    // }
  } catch (error) {
    console.log({ ___: error });
  }
};
